import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import Vivus from 'vivus';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

const animatedElements = document.querySelectorAll('[data-scroll]');

if (animatedElements.length) {
    animatedElements.forEach((element) => {
        const triggerPosition = element.classList.contains('ease-btm') ? '-25 bottom' : '100 bottom';
        ScrollTrigger.create({
            trigger: element,
            start: triggerPosition,
            onEnter: () => {
                element.setAttribute('data-scroll', 'in');
            },
        });
    });
}

if (window.matchMedia('(min-width: 1025px)').matches) {
    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: '.card-animation',
            start: 'top 80%',
            toggleActions: 'play none none none',
            // markers: true,
        },
    });

    tl.fromTo(
        '.animation-line',
        { scaleX: 0 },
        {
            scaleX: 1,
            duration: 1,
            ease: 'power2.out',
            transformOrigin: 'left center',
        },
    );

    tl.fromTo(
        '.animation-card',
        {
            clipPath: 'inset(0 0 100% 0)',
        },
        {
            clipPath: 'inset(0 0 0% 0)',
            duration: 0.6,
            stagger: 0.15,
            ease: 'power2.inOut',
        },
        '-=0.2',
    );
}

document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();

        const target = this.getAttribute('href');
        history.pushState(null, null, target);
        const rootStyles = getComputedStyle(document.documentElement);
        const offsetValue = parseInt(rootStyles.getPropertyValue('--header-height').trim());

        gsap.to(window, {
            duration: 0.6,
            scrollTo: {
                y: target,
                offsetY: offsetValue,
            },
            ease: 'power2.inOut',
        });
    });
});

const lines = document.querySelector('#lines');
if (lines) {
    const circleLeft = document.getElementById('circle-left');
    const circleRight = document.getElementById('circle-right');
    gsap.set([circleLeft, circleRight], {scale: 0, transformOrigin: 'center center'});
    
    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: '#lines',
            start: 'center 80%',
        }
    });
    const tl2 = gsap.timeline();
    const multiplayer = 2;

    const lineVivus = new Vivus('lines', {
        type: 'scenario',
        duration: 80 * multiplayer,
        start: 'manual',
        pathTimingFunction: function (x) {
            // ease-in-out cubic: slow start, fast middle, slow end
            return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2;
        },
        onReady: function (obj) {
            lines.classList.remove('[&_path]:invisible');
        },
    }, function () {
        tl2.to(circleRight, {
            scale: 1,
            duration: 0.5,
            ease: "elastic.out(1, 0.75)",
        });
    });

    tl.to(circleLeft, {
        scale: 1,
        duration: 0.5,
        delay: 0.3,
        ease: "elastic.out(1, 0.75)",
        onComplete: function () {
            lineVivus.play();
        },
    });
}
